



















import Vue from "vue";
import { ConnectivityStatusEnum, connectivityStatusEnumLabel } from "@/model/data/status/ConnectivityStatusEnum";

export default Vue.extend({
    data() {
        return {
            // InstallationStatusEnum,
            selection: [],
        };
    },
    computed: {
        availableData() {
            return Object.values(ConnectivityStatusEnum).filter((x) => !isNaN(parseInt(x.toString())));
        },
    },
    watch: {
        selection() {
            this.$emit("input", this.selection);
        },
    },
    methods: {
        connectivityStatusEnumLabel,
    },
});
